























import { Component, Prop, Vue } from "vue-property-decorator";
import { UrgencyCode } from "@/types/types";
import { decodeVehicleNumber } from "@/services/vehicleNumberDecoder";

@Component({})
export default class ReferralIcon extends Vue {
  @Prop({ default: "UNKNOWN" })
  urgencyCode!: string;

  @Prop({ default: "" })
  status!: string;

  @Prop({ default: "" })
  ambulanceId!: string;

  get urgency(): UrgencyCode {
    return (this.urgencyCode as UrgencyCode) || UrgencyCode.UNKNOWN;
  }

  get urgencyDisplayName(): string {
    return this.urgency === UrgencyCode.UNKNOWN ? "?" : this.urgency;
  }

  get isHeli(): boolean {
    const { vehicle, specialCase } = decodeVehicleNumber(this.ambulanceId);
    const isHelicopter = vehicle === "MMT" && specialCase === "Helikopter";

    return isHelicopter;
  }
}
